import React, { useEffect, useState } from "react";
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import "primeflex/primeflex.css";

import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import classNames from 'classnames'
import Header from "./Header";
import Footer from "./Footer";
import { AuthentificationService } from "./service/AuthentificationService";

function App() {
  const emptyDiplome = {
    idDiplome : '',
    code:'',
    ine : '',
    nom : '',
    prenom : '',
    sexe : '',
    dateNaissance : '',
    lieuNaissance : '',
    domaine : '',
    mention : '',
    specialite : '',
    parcours : '',
    niveau : '',
    iesr : ''
  }
  const [diplome, setDiplome] = useState(emptyDiplome);
  const [loading, setLoading] = useState(false);
  const [studentFind, setStudentFind] = useState(null);
  const [studentId, setStudentId] = useState(null);
  const [authDialog, setAuthDialog] = useState(false);
  const [submitted, setSubmitted] = useState(false)

  const authentificationService = new AuthentificationService()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    

    if (id) {
      //const hashcode = '2bd6a36f86a5712fc703faae02c664afb826ae090a03408490a19e362fcb7e6e'
      setLoading(true);
      authentificationService.getAuthentification(id).then(data => {
        //console.log(data)
        data?setStudentFind(1):setStudentFind(2) 
        setDiplome(data);
        setLoading(false);
        window.history.replaceState({}, document.title, window.location.pathname);
      })
      .catch((error) => {
        console.log(error)
        setLoading(false);
        alert("Erreur lors de la récupération des données de l'étudiant");
      });
    }
    
    else {
        setStudentFind(3)
    }
  }, []);

  const afficheAuth = () => {
    setDiplome({})
    setAuthDialog(true)
  }
  const hideAuthDialog = () => {
    setAuthDialog(false)
  }
  const onDiplomeChange = (e, fieldName) => {
   const val = (e.target && e.target.value) || '';
  let currentDiplome = {...diplome};
    currentDiplome[`${fieldName}`] = val;
    setDiplome(currentDiplome);
  }
  const getDiplomeEtudiant = () => {
      //console.log(diplome.code)
      setLoading(true);
      authentificationService.getAuthentificationCode(diplome.code).then(data => {
        console.log(data)
        data?setStudentFind(1):setStudentFind(2) 
        setDiplome(data);
        setLoading(false);
        setAuthDialog(false)
        window.history.replaceState({}, document.title, window.location.pathname);
      })
      .catch((error) => {
        console.log(error)
        setLoading(false);
        setStudentFind(2)
        //alert("Erreur lors de la récupération des données de l'étudiant");
      });

  }

const Info = ({ label, value }) => (
  <div
    style={{
      display: "flex",
      marginBottom: "0.5rem",
      flexWrap: "wrap",
    }}
  >
    <strong style={{ marginRight: "0.5rem" }}>{label} :</strong>
    <span>{value}</span>
  </div>
)

  const authDialogFooter = (
      <React.Fragment>
          <Button label="Quitter" icon="pi pi-times" className="p-button-text" onClick={hideAuthDialog} />
          <Button label="Lancer la verification" icon='pi pi-check' className="p-button-text" onClick={getDiplomeEtudiant} />
      </React.Fragment>
  );

  return (
    <div style={{ paddingBottom: '80px' }}>
      <Dialog visible={authDialog}  header="Fournir le code du diplôme" modal className="p-fluid" footer={authDialogFooter} onHide={hideAuthDialog}>
        <div className="formgrid grid">
          <div className="field col">
              <label htmlFor="code">Entrez le code sticker du diplôme</label>
              <InputText id="code" value={diplome.code} onChange={(e) => onDiplomeChange(e, 'code')} required  className={classNames({ 'p-invalid': submitted && !diplome.code })}/>
              {submitted && !diplome.code && <small className="p-error">Veuillez renseigner le code du diplôme.</small>}
          </div>
        </div>
      </Dialog>
      <Header/>
      {studentFind===1 ?
       
       <div
      style={{
        textAlign: "center",
        padding: "1rem 1rem",
        backgroundColor: "#f0f4f7",
        paddingBottom: '150px'
      }}
    >
      {/* === Titre principal === */}
      <h1
        style={{
          fontSize: "2rem",
          marginBottom: "1rem",
        }}
        className="md:text-4xl sm:text-2xl font-bold"
      >
        Authentification du diplôme de : {diplome?.nomEtudiant + " " + diplome?.prenomEtudiant}
      </h1>

      {/* === Bande verte d'authentification === */}
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          backgroundColor: "#28a745",
          color: "white",
          borderRadius: "8px",
          padding: "0.75rem 1.5rem",
          gap: "0.5rem",
          marginBottom: "0rem",
        }}
      >
        
        <i className="pi pi-check-circle" style={{ fontSize: "1.5rem" }}></i>
        <span style={{ fontSize: "1.1rem", fontWeight: "500" }}>
          Diplôme authentifié avec succès
        </span>
      </div>

      <Card
        title={`Diplôme de : ${diplome?.intituleDiplome}`}
        style={{
          margin: "2rem auto",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          maxWidth: "900px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#f0f8ff",
              padding: "1rem",
              borderRadius: "8px",
              flex: "1 1 300px",
            }}
          >
            <Info label="INE/Matricule" value={diplome?.ine} />
            <Info label="Nom" value={diplome?.nomEtudiant} />
            <Info label="Prénom" value={diplome?.prenomEtudiant} />
            <Info label="Sexe" value={diplome?.sexeEtudiant} />
            <Info label="Date de naissance" value={diplome?.dateNaissanceEtudiant} />
            <Info label="Lieu de naissance" value={diplome?.lieuNaissanceEtudiant} />
            {/*<Info label="Nationalité" value={diplome?.nationalite} />*/}
          </div>

          
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#e6f7ff",
              padding: "1rem",
              borderRadius: "8px",
              flex: "1 1 300px",
            }}
          >
            <Info
              label="Université"
              value={diplome?.universite}
            />
            <Info label="Diplôme" value={diplome?.intituleDiplome} />
            <Info label="Type diplôme" value={diplome?.typeDocument} />
            <Info label="Domaine" value={diplome?.domaine} />
            <Info label="Mention" value={diplome?.mention} />
            <Info label="Spécialité" value={diplome?.specialite} />
            <Info label="Parcours" value={diplome?.parcours} />
            <Info label="Cote" value={diplome?.cote} />
            <Info label="Année universitaire" value={diplome?.anneeAcademique} />
            <Info label="Référence du diplôme" value={diplome?.referenceDiplome} />
            <Info label="Date d'établissement" value={diplome?.dateEtablissement} />
            <Info label="Nom du signataire" value={diplome?.nomSignataire} />
            <Info label="Prénom du signataire" value={diplome?.prenomSignataire} />
            <Info label="Titre honorifique du signataire" value={diplome?.titreHonorifiqueSignataire} />
            <Info label="Fonction du signataire" value={diplome?.fonctionSignataire} />
            <Info label="Statut du diplôme" value={diplome?.estActif?"Actif":"Inactif"} />
          </div>
        </div>
      </Card>
    </div>
        :
    studentFind === 2 ?
     <div
      style={{
        textAlign: "center",
        padding: "4rem 1rem",
        backgroundColor: "#f0f4f7",
        paddingBottom : 200
      }}
    >
      
      <h1
        className="non-auth-title"
        style={{
          fontSize: "2.5rem",
          marginBottom: "1rem",
          color: "red",
          fontWeight: "bold",
        }}
      >
        Ce document n'est pas produit par une université au Burkina Faso !
      </h1>

      <p
        style={{
          fontSize: "1.2rem",
          marginBottom: "2rem",
          fontStyle: "italic",
          color: "#333",
        }}
      >
        Cliquez sur le bouton ci-dessous pour réessayer l’authentification.
      </p>

      <Button
        label="Recommencer"
        icon="pi pi-refresh"
        onClick={() => window.location.reload()}
        className="p-button-lg p-button-rounded p-button-success"
      />

      <style>
        {`
          @media (max-width: 1024px) {
            .non-auth-title {
              font-size: 2rem;
            }
          }

          @media (max-width: 768px) {
            .non-auth-title {
              font-size: 1.6rem;
              line-height: 1.3;
              padding: 0 0.5rem;
            }

            p {
              font-size: 1rem;
            }

            .p-button-lg {
              font-size: 0.9rem;
              padding: 0.75rem 1.5rem;
            }
          }

          @media (max-width: 480px) {
            .non-auth-title {
              font-size: 1.4rem;
            }

            p {
              font-size: 0.9rem;
            }
          }
        `}
      </style>
    </div>
      
      :
    studentFind === 3 ?
    <>
     
    <div className="flex flex-column min-h-screen">

      <div
        className="flex flex-column justify-content-center align-items-center text-center px-3 py-6 md:py-8"
        style={{
          backgroundImage: "url('/background-campus.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "60vh",
          color: "white",
        }}
      >

        <div
          className="hidden lg:flex flex-column align-items-center bg-black-alpha-70 border-round p-4 md:p-6"
          style={{ maxWidth: "700px" }}
        >
          <h1 className="text-3xl md:text-5xl font-bold mb-3">
            Authentification des diplômes
          </h1>
          <p className="text-lg md:text-xl line-height-3 mb-4">
            Une plateforme sécurisée et rapide pour vérifier les diplômes des
            étudiants issus des universités publiques du Burkina Faso.
          </p>
          <Button
            label="Authentifier"
            icon="pi pi-search"
            className="p-button-rounded p-button-lg p-button-info"
            onClick={afficheAuth}
          />
        </div>

        <div className="flex lg:hidden">
          <Button
            label="Authentifier"
            icon="pi pi-search"
            className="p-button-rounded p-button-lg p-button-info"
            onClick={afficheAuth}
          />
        </div>
      </div>

      <div className="flex flex-wrap justify-content-center gap-4 p-4 md:p-6">
        <Card
          title="Rapide"
          subTitle="Authentifiez un diplôme en un seul clic"
          className="shadow-2 border-round w-18rem sm:w-20rem md:w-22rem"
        >
          <p className="m-0">
            Authentifiez tout diplôme ou attestation définitive en un clin d'œil.
          </p>
        </Card>

        <Card
          title="Fiable"
          subTitle="Des données certifiées"
          className="shadow-2 border-round w-18rem sm:w-20rem md:w-22rem"
        >
          <p className="m-0">
            La seule plateforme authentique pour identifier un diplôme universitaire.
          </p>
        </Card>

        <Card
          title="Sécurisé"
          subTitle="Protection de vos données"
          className="shadow-2 border-round w-18rem sm:w-20rem md:w-22rem"
        >
          <p className="m-0">
            Nous utilisons des standards de sécurité de pointe pour garantir la
            confidentialité et la fiabilité de vos données.
          </p>
        </Card>
      </div>
    </div>
    </>
     :
     ""
    }

      {<Footer stF = {studentFind===3} />}

    </div>
  )
}

export default App;
